import React, {FC, useEffect, useState} from "react";
import {QuestionProps} from "../../../pages/form";
import {Col, InputNumber, Row} from "antd";
import {useDebouncedCallback} from "use-debounce";

// TODO: Merge - add slider option similar as in int-question.tsx
// TODO: Merge - add unit similar as in int-question.tsx
export const DoubleQuestion: FC<QuestionProps> = ({
                                                    question,
                                                    answer,
                                                    onAnswer,
                                                  }) => {
  const doubleQuestion = question?.double;
  const doubleAnswer = answer?.value?.double;

  const [internalValue, setInternalValue] = useState<number>();
  const [internalUnitIdValue, setInternalUnitIdValue] = useState<string>();

  useEffect(() => {
    if (doubleAnswer?.value !== internalValue) {
      setInternalValue(doubleAnswer?.value || undefined);
    }
    if (doubleAnswer?.unitOptionId !== internalUnitIdValue) {
      setInternalUnitIdValue(doubleAnswer?.unitOptionId || undefined);
    }
  }, [doubleAnswer]);

  const answerDebounced = useDebouncedCallback((value: number | undefined) => {
    onAnswer({
      double: {
        value: value,
      },
    });
  }, 400);

  function onValueChange(newValue: number | undefined) {
    setInternalValue(newValue);
    answerDebounced(newValue);
  }

  return (
      <Row>
        <Col flex={"auto"} span={24}>
          <div>
            <InputNumber
                value={internalValue}
                step={0.1}
                onChange={(value) => onValueChange(value || undefined)}
            />
          </div>
        </Col>
      </Row>
  );
};

